require("../libs/backbone/backbone.ajaxq.adapter.ts");
require("../libs/bootstrap/js/bootstrap.min.js");
require("../libs/notify/notify.min.js");
require('../libs/timepicker/js/timepicker.min.js');
require("./global_functions.js");
require ("../libs/chosen/js/chosen.jquery.min.js");
const i18n = require('l10n');

$('html').attr('lang', i18n.lng());

var TheRouter = require("./routers/dashboard.router.ts");
var token = null;
var loggedIn = false;
var data = null;

$.ajaxDefaultQ({
	url: '/rest/api/user?extra=org',
	contentType: 'application/json',
	type: 'GET',
}).done(function(response, status, xhr){
	if(status == "success")
	{
	    if(response.data) {
	        loggedIn = true;
            data = response.data;
	    }
	}
})
.fail(function(response) {

})
.always(function(){
	var router = new TheRouter({token: token, loggedIn: loggedIn, data: data});
	Backbone.history.start();
});






